import axiosPost from '../axiosPost';

export const usuarioStatusGet = async (arg) => {
    const name = 'Usuario status GET';
    let result;

    const { params } = arg

    const body = {
        "service": "UsuarioStatusGet",
        "params": params ? params : {}
    }

    try {
        result = await axiosPost('Y', body, arg)
    } catch (err) {
        console.log(err)
    }

    if (!result || result === null) {
        console.log(`Error getting ${name}`)
    }

    return result.data.result
}